import React from 'react'
import { css } from '@emotion/react'

import Column from 'gatsby-theme-marketplace-base/src/components/Footer/Column'

const overrideColumnCss = css`
  font-size: 16px;
  flex-basis: unset;

  > a {
    color: inherit;
  }
`

export default (props) => <Column {...props} css={overrideColumnCss} />
